import React from 'react'

import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import useDialog from '@/hooks/useDialog'
import PaymentInstructionsModal from '@/pages/rqCertifiedApplicationStatus/components/PaymentInstructionsModal'

const PendingPaymentConfirmationButtons: React.FC = () => {
  const {
    isShowingDialog: isShowingPaymentInstructionsDialog,
    showDialog: showPaymentInstructionsDialog,
    hideDialog: hidePaymentInstructionsDialog,
  } = useDialog()

  const buttonClass = 'w-full md:w-auto cursor-not-allowed'

  return (
    <>
      <Button
        className={buttonClass}
        variant="outline-success"
        onClick={showPaymentInstructionsDialog}
      >
        View payment instructions
      </Button>

      {isShowingPaymentInstructionsDialog && (
        <PaymentInstructionsModal onHide={hidePaymentInstructionsDialog} />
      )}

      <Tooltip>
        <TooltipTrigger asChild>
          <div className={buttonClass}>
            <Button variant="primary" disabled className="w-full sm:w-auto">
              Continue your application
            </Button>
          </div>
        </TooltipTrigger>

        <TooltipContent>
          You will be able to continue your application once we process your
          payment. We'll notify you when this happens.
        </TooltipContent>
      </Tooltip>
    </>
  )
}

export default PendingPaymentConfirmationButtons
